import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css';

const SignupPage = ({ onSignupSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/auth0/signup', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Signup failed');
        setLoading(false);
        return;
      }

      // Signup currently does not auto-issue a session — server returns
      // {result:'ok', success:true}. Send the user to /login to sign in.
      if (data.success || data.result === 'ok') {
        window.location.href = '/login';
      } else {
        setError('Signup failed — unexpected response');
      }
    } catch (err) {
      setError('Connection error — please try again');
    }

    setLoading(false);
  };

  const handleGoogleSignup = () => {
    window.location.href = '/auth/google';
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/assets/dynamic/NumFreeSymbol.png" className="login-logo" alt="" />
          <h2>Create your account</h2>
          <p className="login-tagline">Get a real number, an AI assistant, and your message center in one place.</p>
        </div>

        {error && <div className="login-error" data-testid="signup-error">{error}</div>}

        <form className="login-form" onSubmit={handleSubmit} data-testid="signup-form">
          <div className="login-field">
            <input
              data-testid="signup-name"
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Name"
              autoComplete="name"
            />
          </div>
          <div className="login-field">
            <input
              data-testid="signup-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email"
              autoComplete="email"
              required
              autoFocus
            />
          </div>
          <div className="login-field">
            <input
              data-testid="signup-password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password (8+ characters)"
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>
          <div className="login-field">
            <input
              data-testid="signup-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
              autoComplete="new-password"
              required
            />
          </div>
          <button
            className="login-btn"
            data-testid="signup-submit"
            type="submit"
            disabled={loading}
          >
            {loading && <span className="login-spinner" />}
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div className="login-divider"><span>or</span></div>

        <button
          className="login-google-btn"
          data-testid="signup-google"
          type="button"
          onClick={handleGoogleSignup}
        >
          <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Continue with Google
        </button>

        <div className="login-alt-hint">Already have an account?</div>
        <Link className="login-alt-btn" to="/login" data-testid="signup-go-login">
          Sign in instead
        </Link>
      </div>
    </div>
  );
};

export default SignupPage;
